<div class="app-loader" *ngIf="loading$ | async">
  <mat-spinner diameter="48"></mat-spinner>
</div>
